module.exports = __webpack_public_path__ + "media/unipod/icon-wall-tiling-black-688bf3c3.svg";